import logIFTTTNextAction from "app/lib/ifttt_next_log_action"

const initialState = {
  event: null,
}

export default function logging(state = initialState, action) {
  switch (action.type) {
    case "LOG_EVENT": {
      logIFTTTNextAction(action.payload.eventName, action.payload.eventData)
      return {
        ...state,
        event: action.payload,
      }
    }

    default: {
      return state
    }
  }
}
